import React from 'react';

import QuoteLoop from '../QuoteLoop/QuoteLoop';
import BlockWrapper from './BlockWrapper';

const QuoteLoopBlock = ({ block }) => (
  <BlockWrapper>
    <QuoteLoop quote={block.quote} />
  </BlockWrapper>
);

export default QuoteLoopBlock;
